import React from 'react';
import {
  ContainerDefaultMessage,
  DefaultText
} from '../../common/CardBoardStyled';
import {
  ImageNoReinforcements,
  WrapperMessage
} from '../Styles/ReinforcementsViewStyle';
import NoReinforcements from '../../../../assets/icons/events/noevents.svg';

const DefaultReinforcements = () => (
  <ContainerDefaultMessage data-testid="cmp-button-default-reinforcements">
    <WrapperMessage>
      <ImageNoReinforcements src={NoReinforcements} alt="Sin reforzamientos" />
      <DefaultText>Por el momento, no hay refuerzos disponibles.</DefaultText>
    </WrapperMessage>
  </ContainerDefaultMessage>
);

export default DefaultReinforcements;
